import Swiper from 'swiper';
import Vue from 'vue';
import Card from '../card/card';
import PopupCards from '../popup/cards/popup-cards';
import AnimationFade from '../../core/animation/fade/animation-fade';

export default function () {
  const partners = document.querySelector('.partners');

  if (partners) {
    new Vue({
      el: partners,
      delimiters: ['${', '}}'],
      components: {
        Card,
        PopupCards,
        AnimationFade,
      },
      data: {
        manager: window.manager,
        popupIsOpen: false,
      },
      mounted() {
        const sliderBtns = [].slice.call(this.$el.querySelectorAll('.sliderButtons__btn'));
        const sliderWrp = this.$el.querySelector('.partners__slider');

        if (sliderWrp) {
          const slides = [].slice.call(this.$el.querySelectorAll('.partners__slide'));

          if (slides && slides.length > 1) {
            new Swiper(sliderWrp, {
              slidesPerView: 4,
              spaceBetween: 30,
              resistance: true,
              resistanceRatio: 0,
              navigation: {
                prevEl: sliderBtns[0],
                nextEl: sliderBtns[1],
                disabledClass: 'sliderButtons__btn--disabled',
              },
              breakpoints: {
                1023: {
                  slidesPerView: 3,
                  spaceBetween: 23,
                },
                767: {
                  slidesPerView: 1,
                  spaceBetween: 23,
                },
              },
            });
          }
        }
      },
    });
  }
}



// WEBPACK FOOTER //
// ./blocks/partners/partners.js